import { defineStore } from 'pinia'

export const useEventStore = defineStore('event', {
  state: () => ({
    events: [],
    loading: false,
    error: null
  }),
  getters: {
    activeEvents: (state) => {
      // Only show events that are active and not deleted
      return state.events.filter(e => e.is_active && !e.deleted_at)
    },
    upcomingEvents: (state) => {
      // Events with a date in the future
      const now = new Date()
      return state.events.filter(e => new Date(e.date) > now && e.is_active && !e.deleted_at)
    },
    pastEvents: (state) => {
      // Events with a date in the past
      const now = new Date()
      return state.events.filter(e => new Date(e.date) <= now && e.is_active && !e.deleted_at)
    }
  },
  actions: {
    setEvents(data) {
      this.events = data || []
    },
    setLoading(loading) {
      this.loading = loading
    },
    setError(error) {
      this.error = error
    },
    async fetchEvents() {
      this.setLoading(true)
      this.setError(null)
      try {
        const response = await fetch('https://franchisebrigade.com/admin/api/events')
        if (!response.ok) {
          throw new Error('Failed to fetch events')
        }
        const data = await response.json()
        // Transform API data to match our expected format
        const transformed = data.map(event => ({
          id: event.id,
          title: event.title,
          slug: event.slug,
          description: event.description,
          date: event.date,
          location: event.location,
          video_type: event.video_type,
          image: event.image_url,
          video: event.video_url,
          thumbnail: event.thumbnail,
          is_active: event.is_active,
          deleted_at: event.deleted_at
        }))
        this.setEvents(transformed)
      } catch (error) {
        this.setError(error.message)
        // Fallback to mock data if API fails
        this.setEvents(this.getMockEvents())
      } finally {
        this.setLoading(false)
      }
    },
    getMockEvents() {
      return [
        {
          id: 1,
          title: 'Sample Franchise Expo',
          slug: 'sample-franchise-expo',
          description: 'Sample event description.',
          date: '2025-07-18 09:00:00',
          location: 'Convention Center, New York',
          video_type: null,
          image: 'https://www.franchisebrigade.com/admin/img/logo.png',
          video: null,
          thumbnail: 'https://www.franchisebrigade.com/admin/img/logo.png',
          is_active: 1,
          deleted_at: null
        }
      ]
    }
  }
}) 